module.exports = __webpack_public_path__ + "img/Ornamen_Bulat_02.d127f2ee.png";